import React, { memo } from 'react';
import { MultipleChoice } from "../MultipleChoice";
export var Checkbox = /*#__PURE__*/memo(function (_ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    disabled = _ref.disabled,
    label = _ref.label,
    labelwrap = _ref.labelwrap,
    name = _ref.name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return false;
    } : _ref$onChange,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'big' : _ref$size,
    rightSideNode = _ref.rightSideNode,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Checkbox' : _ref$testName,
    isError = _ref.isError;
  return /*#__PURE__*/React.createElement(MultipleChoice, {
    checked: checked,
    disabled: disabled,
    isError: isError,
    label: label,
    labelwrap: labelwrap,
    name: name,
    onChange: onChange,
    rightSideNode: rightSideNode,
    size: size,
    testName: testName
  });
});